import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CodeInputComponent, CodeInputModule } from 'angular-code-input';
import { AlertComponent } from 'src/app/shared/components/alert/alert.component';

@Component({
  selector: 'app-login-pin',
  templateUrl: './pin-login.component.html',
  styleUrls: ['./pin-login.component.scss'],
  imports: [TranslatePipe, CodeInputModule, AlertComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PinLoginComponent {
  public active = input<number>(1);
  public incorrectPassword = input(false);
  public errors = input<Set<string>>(new Set());
  public credentialSubmit = output<string>();
  public dismissIncorrectPassword = output<void>();
  public clearErrors = output<void>();

  codeInput = viewChild<CodeInputComponent>('codeInput');

  public reset(): void {
    this.codeInput()?.reset();
    this.codeInput()?.focusOnField(0);
  }
}
